import { ANIMATION_FRAMES } from '@enugu/shared';
/** Playback rate per animation (frames per second). Shared by every paper-doll layer, so layers never drift. */
export const ANIMATION_FPS = {
    idle: 5,
    // 8 frames at 12.5 fps = 0.64 s per cycle; at WALK_SPEED (2.5 tiles/s) that is a
    // 1.6-tile stride, the value docs/61 bakes into the walk cycle.
    walk: 12.5,
    sit: 4,
    lie: 3,
    eat: 8,
    phone: 5,
    talk: 8,
    interact: 10,
};
/** Walking speed in tiles per second (docs/40, docs/43: 400 ms per straight tile). */
export const WALK_SPEED = 2.5;
/** Frame index for an animation that has been playing for `timeSec`. Looping. */
export function animationFrame(anim, timeSec) {
    const n = ANIMATION_FRAMES[anim];
    const f = Math.floor(timeSec * ANIMATION_FPS[anim]);
    return ((f % n) + n) % n;
}
